export default __webpack_public_path__ + "static/media/home2.50164e8f.png";